<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Margem"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="row">
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo do Ativo</div>
        <div class="card-body">
          <div class="col-12">
            <div
              class="form-check form-check-inline"
              *ngFor="let item of TiposMercado; index as i"
            >
              <input
                class="form-check-input"
                data-cy="marketTypeId"
                type="radio"
                id="{{ 'tm-' + i + '-id' }}"
                name="marketTypeId"
                [value]="item.id"
                [(ngModel)]="model.marketTypeId"
                (change)="clearFields()"
              />
              <label class="form-check-label" for="{{ 'tm-' + i + '-id' }}">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Operação</div>
        <div class="card-body">
          <div class="col">
            <div>
              <div
                class="form-check form-check-inline"
                *ngFor="let item of TiposCompra; index as i"
              >
                <input
                  class="form-check-input"
                  data-cy="operationTypeId"
                  type="radio"
                  id="{{ 'to-' + i + '-id' }}"
                  name="operationTypeId"
                  [value]="item.id"
                  [(ngModel)]="model.operationTypeId"
                />

                <label class="form-check-label" for="{{ 'to-' + i + '-id' }}">
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Margin"
    [marketType]="model.marketTypeId"
  ></app-dados-fundo>

  <!-- RF - Título Privado -->
  <div class="card mt-3" *ngIf="isRFTituloPrivado()">
    <div class="card-header text-uppercase">
      Dados da Operação - (RF - Título Privado)
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2" [class.has-error]="hasError('amount')">
          <label>Quantidade</label>
          <input
            type="text"
            data-cy="amount"
            class="form-control"
            id="rf-privado-amount"
            name="amount"
            [(ngModel)]="model.amount"
            (ngModelChange)="calculateOperationValue($event)"
          />
        </div>
        <div class="col-2">
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            data-cy="unitPrice"
            class="form-control"
            id="rf-privado-unitPrice"
            name="unitPrice"
            [(ngModel)]="model.unitPrice"
            [textMask]="{ mask: validator.unitPriceMask }"
            (ngModelChange)="calculateOperationValue($event)"
            required
          />
        </div>
        <div class="col-2" [class.has-error]="hasError('operationValue')">
          <label
            >Valor da Operação
            <fa-icon
              *ngIf="isRescue()"
              [icon]="faInfoCircle"
              title="Os valores de resgate poderão sofrer alterações por conta do calculo da cota do fundo."
            ></fa-icon>
          </label>
          <input
            type="text"
            class="form-control"
            data-cy="operationValue"
            id="rf-privado-operationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            required
          />
        </div>
        <app-out-custody></app-out-custody>
      </div>

      <!-- TODO -->
      <div class="row mb-2">
        <div class="col-6">
          <label>Nome do Ativo</label>
          <input
            type="text"
            class="form-control"
            data-cy="securityType"
            id="rf-privado-securityType"
            name="securityType"
            [(ngModel)]="model.securityType"
            maxlength="10"
            required
          />
        </div>

        <div class="col-6">
          <label>Código Ativo</label>
          <input
            type="text"
            class="form-control"
            data-cy="securityCode"
            id="rf-privado-securityCode"
            name="securityCode"
            [(ngModel)]="model.securityCode"
            maxlength="10"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6" [class.has-error]="hasError('expirationDate')">
          <label>Data Vencimento</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="expirationDate"
            data-cy="expirationDate"
            [(ngModel)]="model.expirationDate"
            required
          />
        </div>
        <div class="col-6" [class.has-error]="hasError('purchaseDate')">
          <label>Data Aquisição</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="purchaseDate"
            data-cy="purchaseDate"
            [(ngModel)]="model.purchaseDate"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <label>Emissor</label>
          <input
            type="text"
            data-cy="issuer"
            class="form-control"
            name="issuer"
            [(ngModel)]="model.issuer"
            maxlength="90"
          />
        </div>
        <div class="col-6">
          <label>Comando</label>
          <input
            class="form-control text-box single-line"
            id="rf-privado-command"
            data-cy="command"
            name="command"
            type="text"
            value=""
            [(ngModel)]="model.command"
            maxlength="10"
            required
          />
        </div>
      </div>
    </div>
  </div>

  <!-- RF - Título Público -->
  <div class="card mt-3" *ngIf="isRFTituloPublico()">
    <div class="card-header text-uppercase">
      Dados da Operação - (RF - Título Público)
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2" [class.has-error]="hasError('amount')">
          <label>Quantidade</label>
          <input
            type="text"
            class="form-control"
            id="rf-publico-amount"
            data-cy="publicAmount"
            name="amount"
            [(ngModel)]="model.amount"
            [textMask]="{ mask: validator.decimalIndexFeeMask }"
            (ngModelChange)="calculateOperationValue($event)"
          />
        </div>
        <div class="col-2">
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            class="form-control"
            id="rf-publico-unitPrice"
            name="unitPrice"
            data-cy="publicUnitPrice"
            [(ngModel)]="model.unitPrice"
            [textMask]="{ mask: validator.unitPriceMask }"
            (ngModelChange)="calculateOperationValue($event)"
            required
          />
        </div>
        <div class="col-2" [class.has-error]="hasError('operationValue')">
          <label>Valor da Operação</label>
          <input
            type="text"
            class="form-control"
            id="rf-publico-operationValue"
            name="operationValue"
            data-cy="publicOperationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            required
          />
        </div>
        <app-out-custody></app-out-custody>
      </div>
      <div class="row mb-2">
        <div class="col-6" [class.has-error]="hasError('securityName')">
          <label>Nome do Título</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="selectedPublicSecurity"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityTypeSelected()"
            [disabled]="!canEdit()"
          >
            <ng-option
              *ngFor="let item of publicSecurityTypes"
              [value]="item"
              >{{ item }}</ng-option
            >
          </ng-select>
        </div>
        <div class="col-6" [class.has-error]="hasError('securityCode')">
          <label>Código Título</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="model.securityCode"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityIdSelected()"
            [disabled]="!canEdit()"
          >
            <ng-option
              *ngFor="let publicSecurity of publicSecurityIdsList"
              [value]="publicSecurity"
              >{{ publicSecurity }}</ng-option
            >
          </ng-select>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('expirationDate')">
          <label>Data Vencimento</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="selectedPublicSecurityItem"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityItemSelected()"
            [disabled]="!canEdit()"
          >
            <ng-option
              *ngFor="let publicSecurity of publicSecurityList"
              [value]="publicSecurity"
              >{{ publicSecurity.expirationDate }}</ng-option
            >
          </ng-select>
        </div>
        <div class="col-4" [class.has-error]="hasError('purchaseDate')">
          <label>Data Aquisição</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="purchaseDate"
            data-cy="publicPurchaseDate"
            [(ngModel)]="model.purchaseDate"
            required
          />
        </div>
        <div class="col-4">
          <label>Comando</label>
          <input
            class="form-control text-box single-line"
            id="rf-publico-command"
            data-cy="publicCommand"
            name="command"
            type="text"
            [(ngModel)]="model.command"
            maxlength="10"
            required
          />
        </div>
      </div>
    </div>
  </div>

  <!-- RendaVariavel -->
  <div class="card mt-3" *ngIf="isRendaVariavel()">
    <div class="card-header text-uppercase">
      Dados da Operação (Renda Variável)
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2" [class.has-error]="hasError('amount')">
          <label>Quantidade</label>
          <input
            type="text"
            class="form-control"
            id="rv-amount"
            name="amount"
            data-cy="rvAmount"
            [(ngModel)]="model.amount"
            [textMask]="{ mask: validator.decimalIndexFeeMask }"
          />
        </div>
        <div class="col-2">
          <label>Cotação</label>
          <input
            type="text"
            class="form-control"
            id="rv-quotation"
            data-cy="rvQuotation"
            name="quotation"
            [(ngModel)]="model.quotation"
            [textMask]="{ mask: validator.quotationMask }"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <label>Nome do Papel</label>
          <input
            type="text"
            class="form-control"
            id="rv-asset"
            data-cy="rvAsset"
            name="asset"
            [(ngModel)]="model.asset"
            maxlength="90"
            required
          />
        </div>
        <div class="col-6">
          <label>Comando</label>
          <input
            class="form-control text-box single-line"
            id="rv-command"
            name="command"
            data-cy="rvCommand"
            type="text"
            [(ngModel)]="model.command"
            maxlength="10"
            required
          />
        </div>
      </div>
    </div>
  </div>

  <!-- DINHEIRO -->
  <div class="card mt-3" *ngIf="isDinheiro()">
    <div class="card-header text-uppercase">Dados da Operação (DINHEIRO)</div>

    <div class="card-body">
      <div class="row mb-2">
        <div class="col-6">
          <label>Valor da Operação</label>
          <input
            type="text"
            class="form-control"
            id="dinheiro-operationValue"
            data-cy="cashOperationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <label data-cy="hasSameOwnership" for="hasSameOwnership"
            >Mesma Titularidade</label
          >
          <input
            class="form-check-input"
            id="hasSameOwnership"
            name="hasSameOwnership"
            [(ngModel)]="model.hasSameOwnership"
            type="checkbox"
          />
        </div>
      </div>
    </div>
  </div>

  <br />

  <app-counterpart
    [isRFPrivateMargin]="isRFTituloPrivado()"
    [isRFPublicMargin]="isRFTituloPublico()"
    [isVariableIncomeMargin]="isRendaVariavel()"
    [isMoneyMargin]="isDinheiro()"
    #counterpart
    [ticketType]="TicketTypeEnum.Margin"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="this.model"
  >
  </app-counterpart>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <mat-expansion-panel *ngIf="showTransferStatus()" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Dados da Transferência </mat-panel-title>
      <mat-panel-description> (Clique para expandir...) </mat-panel-description>
    </mat-expansion-panel-header>
    <div style="padding: 1rem">
      <app-transfer-status
        #transferstatus
        [ticketId]="model.id"
      ></app-transfer-status>
    </div>
  </mat-expansion-panel>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Encaminhar"
      data-cy="forward"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
